import React, { ReactNode } from 'react';
import clsx from 'clsx';

import styles from './styles.module.scss';

type InputProps = {
  children: ReactNode | string;
  className?: string;
};

export const TitleH3 = ({ children, className }: InputProps) => {
  return <h3 className={clsx(styles.root, className)}>{children}</h3>;
};
